/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope).

   Astryx has no primitive for multi-line truncation, so the clamp lives here
   rather than as an inline style in a consuming page. The line count is bound
   through a custom property so the component stays parameterised without
   reintroducing inline styling rules. */

.clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--expandable-text-lines, 2);
  overflow: hidden;
}
